var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.monthlyCostStyle},[_vm._v(" "+_vm._s(_vm._f("prettyMoney")(_vm.amount))+" "),(_vm.monthlyCostIcon)?_c('span',{class:_vm.monthlyCostIcon}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }